// extracted by mini-css-extract-plugin
module.exports = {"reviewsScoresSummary":"_1Vv0i","reviewScoreItem":"_2qVtb","star":"_1XW5s","separator":"_35Vpe"};